import { Component, Input } from "@angular/core";

@Component({
  selector: "app-strapi-quote",
  templateUrl: "./strapi-quote.component.html",
  styleUrls: ["./strapi-quote.component.sass"],
})
export class StrapiQuoteComponent {
  @Input() data: any;
}
